var _rect, _path, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfileMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 40,
    rx: 4,
    fill: "#F1EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2086 20.4146C23.6582 19.3122 21.7781 18.6215 19.1766 17.6653L18.3712 17.3654C18.3358 17.3521 18.3052 17.3285 18.2833 17.2976C18.2615 17.2667 18.2496 17.23 18.2489 17.1921V15.6008C18.2489 15.5744 18.2545 15.5482 18.2652 15.5241C18.2759 15.4999 18.2916 15.4783 18.3112 15.4606C18.9099 14.9257 19.2848 14.1847 19.3611 13.3855C19.3649 13.3422 19.3837 13.3016 19.4143 13.2708C19.5841 13.0798 19.6993 12.8467 19.748 12.5958C19.8177 12.3518 19.8323 12.0953 19.7909 11.8449C19.7496 11.5945 19.6532 11.3564 19.5088 11.1477C19.4878 11.1215 19.474 11.0903 19.469 11.0571C19.464 11.0239 19.4679 10.9899 19.4803 10.9587C19.9736 9.96883 20.1934 8.86512 20.117 7.76178C19.868 6.5184 18.1155 6.03769 16.6906 6.00169C15.5049 5.9762 14.0403 6.23492 13.5341 7.0246C13.5198 7.04704 13.501 7.06619 13.4787 7.0808C13.4565 7.0954 13.4314 7.10513 13.4051 7.10934C13.2196 7.1314 13.0404 7.19082 12.8783 7.284C12.7163 7.37719 12.5749 7.50221 12.4625 7.65154C11.6841 8.70144 12.5675 11.0262 12.5442 10.9512C12.5534 10.9814 12.5548 11.0135 12.5484 11.0444C12.542 11.0753 12.5279 11.1041 12.5075 11.1282C12.3563 11.3371 12.2545 11.5776 12.2098 11.8316C12.1651 12.0856 12.1787 12.3464 12.2495 12.5943C12.2982 12.8452 12.4135 13.0783 12.5832 13.2693C12.6139 13.3 12.6328 13.3407 12.6365 13.384C12.7127 14.1832 13.0877 14.9242 13.6864 15.4591C13.7063 15.4769 13.7222 15.4987 13.7331 15.5232C13.7439 15.5476 13.7495 15.5741 13.7494 15.6008V17.1921C13.7494 17.2305 13.7376 17.2679 13.7158 17.2994C13.694 17.3309 13.663 17.3549 13.6271 17.3684L12.8202 17.6683C10.2187 18.6245 8.33937 19.3182 7.78968 20.4176C7.3042 21.4194 7.03513 22.5123 7 23.625C7 23.7245 7.03951 23.8199 7.10982 23.8902C7.18014 23.9605 7.27552 24 7.37496 24H24.6233C24.7228 24 24.8182 23.9605 24.8885 23.8902C24.9588 23.8199 24.9983 23.7245 24.9983 23.625C24.9636 22.5113 24.6945 21.4174 24.2086 20.4146Z",
    fill: "#C9B3FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 28,
    width: 18,
    height: 2,
    fill: "#C9B3FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 32,
    width: 12,
    height: 2,
    fill: "#C9B3FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileMenu);
export default __webpack_public_path__ + "static/media/profile-menu.08941c25d0723a7d2e4c65c00aa1a74f.svg";
export { ForwardRef as ReactComponent };